import React, { useState } from "react";
import notificationIcon from "../assets/icons/notification_icon.png";
import searchIcon from "../assets/icons/search_icon.png";
import { Link } from "react-router-dom";
import NotificationModal from "./modals/NotificationModal";

const SearchBar = ({ categoryName }) => {
  const [notification, setNotification] = useState(false);
  return (
    <>
      <div className="w-full">
        <div className="flex justify-between w-[95%] items-center bg-[#F9F9F9] mt-4 ml-4 rounded-lg shadow-lg">
          <div className="text-[#2F80ED] text-[16px] flex items-center pl-4">
            <Link to="/dashboard">
              <span className="text-black text-2xl mr-3">&#60;</span>
            </Link>
            <span className="cursor-pointer">{categoryName}</span>
          </div>
          <div className="flex bg-[#FFFFFF] px-4 rounded-xl w-[50%]">
            <img
              src={searchIcon}
              className="object-cover w-10 p-2"
              alt="search"
            />
            <input
              placeholder="Search..."
              className="bg-[#FFFFFF] p-1 w-full"
            />
          </div>
          <div onClick={() => setNotification(true)}>
            <img
              src={notificationIcon}
              className="w-16 cursor-pointer"
              alt="notification"
            />
          </div>
        </div>
      </div>
      <div className="z-20">
        {notification ? (
          <NotificationModal setNotification={setNotification} />
        ) : null}
      </div>
    </>
  );
};

export default SearchBar;
